// extracted by mini-css-extract-plugin
module.exports = {"date":"PanelHeader_date__2dtep","label":"PanelHeader_label__1GQdp"};